import { render, staticRenderFns } from "./BlockMember.vue?vue&type=template&id=5dc9b454&scoped=true&"
import script from "./BlockMember.vue?vue&type=script&lang=js&"
export * from "./BlockMember.vue?vue&type=script&lang=js&"
import style0 from "./BlockMember.vue?vue&type=style&index=0&id=5dc9b454&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc9b454",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dc9b454')) {
      api.createRecord('5dc9b454', component.options)
    } else {
      api.reload('5dc9b454', component.options)
    }
    module.hot.accept("./BlockMember.vue?vue&type=template&id=5dc9b454&scoped=true&", function () {
      api.rerender('5dc9b454', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Camstudy/control/BlockMember.vue"
export default component.exports